









export default {
  props: {
    icon: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: '',
    },
    size: {
      type: String,
      default: 'sm',
    },
    reverseColor: {
      type: Boolean,
      default: false,
    },
  },
}
